import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import store from '../store'

Vue.use(Router)

let router = new Router({
  mode: 'history',

  linkActiveClass: 'active',

  routes
})

router.beforeEach((to, from, next) => {
  if (to.name === 'home') {
    next()
  } else {
    if (store.state.flowType == null) {
      next({
        name: 'home'
      })
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js